import { render } from "./AppDropdown.vue?vue&type=template&id=090e23de&scoped=true&lang=pug"
import script from "./AppDropdown.vue?vue&type=script&lang=js"
export * from "./AppDropdown.vue?vue&type=script&lang=js"

import "./AppDropdown.vue?vue&type=style&index=0&id=090e23de&lang=scss&scoped=true"

import exportComponent from "/Users/edsonfer/Documents/dev-projects/node-projects/portal-gignet-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-090e23de"]])

export default __exports__